interface CTAProps {
  onBookClick: () => void;
}

export default function CTA({ onBookClick }: CTAProps) {
  return (
    <section className="relative py-32 px-6 bg-gradient-to-b from-black to-zinc-950">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Ready for an Unforgettable Experience?
        </h2>
        
        <p className="text-xl text-gray-400 mb-12 leading-relaxed max-w-2xl mx-auto">
          Book Thomas for your next event and create memories that will last a lifetime
        </p>

        <button 
          onClick={onBookClick}
          className="group px-12 py-5 bg-red-600 text-white text-lg font-semibold rounded-full hover:bg-red-700 transition-all duration-300 hover:shadow-2xl hover:shadow-red-600/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
        >
          Book Thomas Now
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
        </button>
      </div>
    </section>
  );
}
